<button
  [class]="buttonClass"
  [disabled]="isLoading || disabled"
>
  <i *ngIf="isLoading" [class]="spinnerClass"></i>
  <bi *ngIf="iconName" [name]="iconName"></bi>
  <ng-content></ng-content>
</button>
